import Dexie from "dexie";

// Initialize DB: "POS_PrintGuard"
// Schema: printedOrders (orderId, timestamp)
const db = new Dexie("POS_PrintGuard");
db.version(1).stores({
  printedOrders: "orderId, timestamp"
});

/**
 * Checks if the order has been printed locally.
 * @param {string} orderId 
 * @returns {Promise<boolean>}
 */
export const hasPrintedLocal = async (orderId) => {
  if (!orderId) return false;
  try {
    const count = await db.printedOrders.where("orderId").equals(orderId).count();
    return count > 0;
  } catch (error) {
    console.error("PrintGuard: Error checking local DB", error);
    return false; // Fail safe
  }
};

/**
 * Marks an order as printed in local DB.
 * @param {string} orderId 
 */
export const markPrintedLocal = async (orderId) => {
  if (!orderId) return;
  try {
    await db.printedOrders.put({
      orderId,
      timestamp: Date.now()
    });

    // Optional: Auto-cleanup (1% chance to run)
    if (Math.random() < 0.01) {
      cleanOldRecords();
    }
  } catch (error) {
    console.error("PrintGuard: Error marking printed", error);
  }
};

const cleanOldRecords = async () => {
  try {
    const count = await db.printedOrders.count();
    if (count > 20000) {
      const thirtyDaysAgo = Date.now() - (30 * 24 * 60 * 60 * 1000);
      await db.printedOrders.where("timestamp").below(thirtyDaysAgo).delete();
    }
  } catch (e) { console.error("PrintGuard Cleanup Error", e); }
};

export const initPrintGuardSync = () => { };